<template>
    <full-screen-dialog parameter="passVorschau" value="true" >
        <toolbar title="Pässe drucken" :show-back="true"/>
        <paesse-drucken-vorschau-inhalt/>
    </full-screen-dialog>
</template>

<script>

import FullScreenDialog from "@/components/elements/fullScreenDialog";
import PaesseDruckenVorschauInhalt from "@/views/paesse/drucken/paesseDruckenVorschauInhalt";
import Toolbar from "@/components/elements/toolbar";
export default {
    name: "paesse-drucken-vorschau",
    components: {Toolbar, PaesseDruckenVorschauInhalt, FullScreenDialog},
}
</script>

<style scoped>

</style>